import { render, staticRenderFns } from "./SnapshotSelectionGalleryNew.vue?vue&type=template&id=f6a452ee&scoped=true"
import script from "./SnapshotSelectionGalleryNew.vue?vue&type=script&lang=js"
export * from "./SnapshotSelectionGalleryNew.vue?vue&type=script&lang=js"
import style0 from "./SnapshotSelectionGalleryNew.vue?vue&type=style&index=0&id=f6a452ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a452ee",
  null
  
)

export default component.exports